<template>
  <div class="logs-grid-row" role="row">
    <div class="logs-grid-cell logs-grid-id" role="cell">
      {{ source.id_movimiento }}
    </div>
    <div class="logs-grid-cell logs-grid-date" role="cell">
      <small class="text-muted">{{ source.fecha }}</small>
    </div>
    <div class="logs-grid-cell logs-grid-user" role="cell">
      <span class="font-weight-bold d-block text-nowrap text-capitalize">
        {{ source.nombre_completo }}
      </span>
      <small class="text-muted text-capitalize">{{ source.rol }}</small>
    </div>
    <div class="logs-grid-cell logs-grid-section" role="cell">
      <small class="font-weight-bold text-nowrap text-capitalize">
        {{ source.tipo_dato }}
      </small>
    </div>
    <div class="logs-grid-cell logs-grid-description" role="cell">
      <span class="font-weight-bold ">{{ source.accion }}</span>
    </div>
    <div class="logs-grid-cell logs-grid-type" role="cell">
      <b-badge
        pill
        :variant="
          source.tipo === `leve`
            ? 'light-secondary'
            : source.tipo === `moderada`
            ? 'warning'
            : 'danger'
        "
      >
        {{ source.tipo }}
      </b-badge>
    </div>
    <div class="logs-grid-cell logs-grid-actions" role="cell">
      <feather-icon
        v-if="source.detalle != null && source.detalle != ''"
        icon="TrelloIcon"
        class="cursor-pointer mr-1"
        size="16"
        @click="onShowDetails(source)"
      />
      <feather-icon
        v-if="isSuperUser"
        icon="XIcon"
        class="cursor-pointer"
        size="16"
        @click="onDelete(source)"
      />
    </div>
  </div>
</template>

<script>
import { BBadge } from 'bootstrap-vue'

export default {
  components: { BBadge },
  props: {
    source: {
      type: Object,
      required: true,
    },
    isSuperUser: {
      type: Boolean,
      default: false,
    },
    onShowDetails: {
      type: Function,
      required: true,
    },
    onDelete: {
      type: Function,
      required: true,
    },
  },
}
</script>
